import IntroductionQuestions from './IntroductionQuestions';

export default IntroductionQuestions;
